import clsx from 'clsx';
import { Link } from 'react-router-dom';
import useRoutes from '../../../hooks/useRoutes';
import { useUserState } from '../../../hooks/context/useUserState';
import { useCfgParam } from '../../../hooks/useCfgParam';

const Logo = () => {
  const routes = useRoutes();
  const appName = useCfgParam('appName');
  const {
    state: { username },
  } = useUserState();

  return (
    <Link
      to={routes.home()}
      slot={username ? 'start' : undefined}
      className={clsx('logo', username && 'hide-mobile')}
    >
      <img src="/images/logo.svg" alt={appName} />
    </Link>
  );
};

export default Logo;
